require('./ripple.less');

jQuery(function() {
    $(document).on('click', '.js-ripple', function(e) {
        var $this = $(this);

        var $offset = $this.offset();
        var $circle = $this.find('.ripple__circle').removeClass('is-active');

        if ($circle.length == 0) {
            $this.append('<span class="ripple__circle"></span>');
            $circle = $this.find('.ripple__circle');
        }
        var x = e.pageX - $offset.left;
        var y = e.pageY - $offset.top;

        $circle.css({
            top: y + 'px',
            left: x + 'px'
        });

        $this.addClass('ripple--active');

        $this.on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function() {
            $(this).removeClass('ripple--active');
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/ripple/ripple.js